export type DiagramMarkersProps = {
  prefix?: string;
};

export function DiagramMarkers({ prefix = "" }: DiagramMarkersProps) {
  return (
    <defs>
      <marker
        id={`${prefix}arrow-green`}
        viewBox="0 0 10 10"
        refX="7"
        refY="5"
        markerWidth="6"
        markerHeight="6"
        orient="auto-start-reverse"
      >
        <path d="M 0 1.5 L 9 5 L 0 8.5 z" fill="var(--ga-diagram-success)" />
      </marker>

      <marker
        id={`${prefix}arrow-blue`}
        viewBox="0 0 10 10"
        refX="7"
        refY="5"
        markerWidth="6"
        markerHeight="6"
        orient="auto-start-reverse"
      >
        <path d="M 0 1.5 L 9 5 L 0 8.5 z" fill="var(--ga-diagram-agent)" />
      </marker>

      <marker
        id={`${prefix}arrow-fallback`}
        viewBox="0 0 10 10"
        refX="7"
        refY="5"
        markerWidth="6"
        markerHeight="6"
        orient="auto-start-reverse"
      >
        <path d="M 0 1.5 L 9 5 L 0 8.5 z" fill="var(--ga-diagram-danger)" />
      </marker>

      <marker
        id={`${prefix}arrow-repair`}
        viewBox="0 0 10 10"
        refX="7"
        refY="5"
        markerWidth="6"
        markerHeight="6"
        orient="auto-start-reverse"
      >
        <path d="M 0 1.5 L 9 5 L 0 8.5 z" fill="var(--ga-diagram-repair)" />
      </marker>

      <marker
        id={`${prefix}arrow-neutral`}
        viewBox="0 0 10 10"
        refX="7"
        refY="5"
        markerWidth="6"
        markerHeight="6"
        orient="auto-start-reverse"
      >
        <path d="M 0 1.5 L 9 5 L 0 8.5 z" fill="currentColor" opacity="0.4" />
      </marker>
    </defs>
  );
}
